'use client';
import { jsx } from 'react/jsx-runtime';
import t from 'prop-types';
import { tokens } from '../../../core/tokens/index.js';
import { SpacePropType, SpaceDensityPropType } from '../../../core/types/swan-style.types.js';
import { spaceTokensMap } from '../../../core/utilities/swan-style.utils.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

function _define_property(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[t] = r, e;
}
function _object_spread(e) {
    for(var t = 1; t < arguments.length; t++){
        var r = null != arguments[t] ? arguments[t] : {}, n = Object.keys(r);
        "function" == typeof Object.getOwnPropertySymbols && (n = n.concat(Object.getOwnPropertySymbols(r).filter(function(e) {
            return Object.getOwnPropertyDescriptor(r, e).enumerable;
        }))), n.forEach(function(t) {
            _define_property(e, t, r[t]);
        });
    }
    return e;
}
function ownKeys(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        r.push.apply(r, n);
    }
    return r;
}
function _object_spread_props(e, t) {
    return t = null != t ? t : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
        Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    }), e;
}
function _object_without_properties(e, t) {
    if (null == e) return {};
    var r, n, o = _object_without_properties_loose(e, t);
    if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);
        for(n = 0; n < i.length; n++)r = i[n], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (o[r] = e[r]);
    }
    return o;
}
function _object_without_properties_loose(e, t) {
    if (null == e) return {};
    var r, n, o = {}, i = Object.keys(e);
    for(n = 0; n < i.length; n++)r = i[n], t.indexOf(r) >= 0 || (o[r] = e[r]);
    return o;
}
let p = Object.keys({
    alignItems: t.oneOf([
        'stretch',
        'center',
        'start',
        'end',
        'flex-start',
        'flex-end',
        'baseline',
        'inherit',
        'initial',
        'revert',
        'unset'
    ]),
    flexWrap: t.oneOf([
        'nowrap',
        'wrap',
        'wrap-reverse',
        'inherit',
        'initial',
        'revert',
        'unset'
    ]),
    flexDirection: t.oneOf([
        'row',
        'row-reverse',
        'column',
        'column-reverse',
        'inherit',
        'initial',
        'revert',
        'unset'
    ]),
    justifyContent: t.oneOf([
        'stretch',
        'center',
        'start',
        'end',
        'flex-start',
        'flex-end',
        'left',
        'right',
        'normal',
        'space-between',
        'space-around',
        'space-evenly',
        'inherit',
        'initial',
        'revert',
        'unset'
    ]),
    gap: t.oneOf([
        ...SpacePropType,
        ...SpaceDensityPropType
    ])
}), l = _object_spread_props(_object_spread({}, spaceTokensMap), {
    'between-sections': tokens.SwanSemSpaceBetweenSections,
    'between-subsections': tokens.SwanSemSpaceBetweenSubsections,
    'between-actions': tokens.SwanSemSpaceBetweenActions,
    'to-actions': tokens.SwanSemSpaceToActions,
    'between-icon-and-text': tokens.SwanSemSpaceBetweenIconAndText
});
const FlexBox = renderWithRef('FlexBox', null, (t, r)=>{
    var { children: n, style: o = {}, alignItems: i, flexWrap: c, flexDirection: a, justifyContent: f, gap: u } = t, b = _object_without_properties(t, [
        "children",
        "style",
        "alignItems",
        "flexWrap",
        "flexDirection",
        "justifyContent",
        "gap"
    ]);
    let y = _object_spread_props(_object_spread({}, o), {
        alignItems: null !== i ? i : void 0,
        flexWrap: null !== c ? c : void 0,
        flexDirection: null !== a ? a : void 0,
        justifyContent: null !== f ? f : void 0,
        gap: null != u ? l[u] : void 0
    });
    return jsx(RenderComp, {
        root: "div",
        forwardedRef: r,
        props: _object_spread_props(_object_spread({}, b), {
            style: y
        }),
        propKeysToRemove: p,
        classNames: [
            'swan-display-flex'
        ],
        children: n
    });
});

export { FlexBox };
